import React from 'react';
import parts from '../moduleCard/moduleParts.module.css';
import styles from './scales.module.css';
import ScaleOptionGrid from './ScaleOptionGrid';
import { fieldsCode, toggleFieldValue } from '../../modules/scales/scaleValues';

/**
 * Vários campos nomeados, cada um com seus cards de escolha única (ex.: os
 * quatro eixos de Baumann, ou teste, localização e largura da diástase).
 * Quando a escala declara `code`, o resultado calculado aparece logo abaixo.
 */
const ScaleFieldGroups = ({ scale, value, onChange, readOnly, gender }) => {
  const fields = (value && value.fields) || {};
  const code = fieldsCode(scale, value);

  return (
    <>
      {(scale.fields || []).map((field) => (
        <div key={field.key} className={styles.answer}>
          <span className={parts.sectionLabel}>{field.label}</span>
          <ScaleOptionGrid
            options={field.options}
            selected={fields[field.key] ? [fields[field.key]] : []}
            onToggle={(optionValue) => onChange(toggleFieldValue(scale, value, field.key, optionValue))}
            readOnly={readOnly}
            gender={gender}
          />
        </div>
      ))}
      {code && (
        <span className={`${parts.chip} ${parts.chipAccent} ${styles.difference}`}>{scale.code.label}: {code}</span>
      )}
    </>
  );
};

export default ScaleFieldGroups;
